import React, { Component } from "react";
import { Link, withRouter, Redirect } from "react-router-dom";
import logoHere from "./../../public/images/logo.png";
import logoHere2 from "./../../public/images/logoWhiteLabel.png";

import "./../../public/scss/generic.scss";

import PropTypes from "prop-types";
import { switchToWhiteLabelView, doLogin } from "./../../actions/feedActions";

import { connect } from "react-redux";
import { validateEmailAddress, validateIfTeacher, isMobileBrowser } from "./../../actions/utility";

import Switch from "react-switch";

import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  NavbarText,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  Button,
  Container,
  Row,
  Media,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  FormGroup,
  Input,
  Col,
  DropdownItem,
  DropdownToggle,
  Dropdown,
  DropdownMenu,
  Label,
  // NavLink
} from "reactstrap";
import { faYenSign } from "@fortawesome/free-solid-svg-icons";
import { getToken } from "../../actions/emActions";

class HeaderForTeacher extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      logoImage: window.location.host != "feeds.lincolnmethod.com" ? logoHere2 : logoHere,
      // logoImage: this.props.whiteLabel == true ? logoHere2 : logoHere,
      studentName: "Haseeb Patel",
      isTuitionsPostType: this.props.whiteLabel ? false : true,
      showLoginModal: false,
      email: "",
      password: "",
      credError: "",
      isTeacherLoggedIn: false,
      isEmLoggedIn: false,
      loginType: "",
      emName: "",
      imageName: "",
      loginLoader: false,
      switchRoute: false,
      multipleRole: false,
    };

    this.toggleModal = this.toggleModal.bind(this);
    this.logout = this.logout.bind(this);
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  componentWillReceiveProps(nextProps, thisProps) {
    if (this.props.headerData != nextProps.headerData) {
      this.setState({
        studentName: nextProps.headerData.studentName,
      });
    }

    // for login response
    if (
      typeof nextProps.loginSuccessNormal === "object" &&
      nextProps.loginSuccessNormal.status == "error" &&
      nextProps.loginSuccessNormal.message &&
      nextProps.loginSuccessNormal.message.length
    ) {
      // showing here the incorrect credentials msg
      this.setState({
        credError: nextProps.loginSuccessNormal.message,
      });
    } else if (
      typeof nextProps.loginSuccessNormal === "object" &&
      nextProps.loginSuccessNormal.status == "success"
    ) {
      console.log("login has been succcessfull");
      try {
        var tempData = nextProps.loginSuccessNormal;
        var isTeacher = tempData.is_teacher;
        debugger;
        if (isTeacher && isTeacher == 1) {
          this.setState(
            {
              showLoginModal: false,
            },
            () => {
              localStorage.setItem("loginData", JSON.stringify(nextProps.loginSuccessNormal));
              window.location.reload();
              // console.log(tempData);
            }
          );
        } else {
          this.setState({
            showLoginModal: false,
          });
          localStorage.setItem("loginData", JSON.stringify(nextProps.loginSuccessNormal));
          getToken(tempData?.user?.user_id).then((res) => {
            debugger;
            localStorage.setItem("loginToken", res.data.accessToken);
          });
          debugger;
          // window.location.reload();
        }
      } catch (err) {
        console.log("loginData could not store:", err);
      }
    }
    debugger;
  }

  onToggleSwitch = () => {
    this.setState(
      {
        isTuitionsPostType: !this.state.isTuitionsPostType,
      },
      () => {
        if (this.state.isTuitionsPostType) {
          this.props.switchToWhiteLabelView("tuitions");
        } else {
          this.props.switchToWhiteLabelView("dashboard");
        }
      }
    );
  };

  componentDidMount() {
    var showModal = window.location.hash.split("#/")[1] == "" ? true : false;
    // localStorage.clear();

    // if(!this.props.whiteLabel){
    //   this.onToggleSwitch();
    // }
    try {
      var loginStatus = localStorage.getItem("loginData");
      if (loginStatus != null && typeof JSON.parse(loginStatus) === "object") {
        this.setState({
          showLoginModal: false,
          isTeacherLoggedIn: validateIfTeacher() ? true : false, // if teacher is logged in not student
          emName: JSON.parse(loginStatus).user.user_name,
          loginType: JSON.parse(loginStatus).user_type,
          multipleRole: JSON.parse(loginStatus).is_em,
          imageName: JSON.parse(loginStatus).user.image,
        });
        // var x = document.cookie;
        // var ca = x.split(';');
        // var build = ca[1].replace(' username=','');
        // var releasebuild = 3.0;
        // if(releasebuild == build){
        //     debugger;
        // }
        // else{
        //     debugger;
        //     localStorage.removeItem("loginData");
        //     document.cookie = "username=3.0;";
        //     this.props.history.push("/");
        //     window.location.reload();
        //   }
        // console.log("COOKIE", build );
        // var x2 = document.cookie;
        // var ca2 = x2.split(';');
        // var build2 = ca2[1].replace(' username=','');
        // console.log("COOKIE", build2 );
      } else {
        this.setState({
          showLoginModal: showModal,
        });
      }
    } catch (err) {
      this.setState({
        showLoginModal: showModal,
      });
    }
  }

  toggleModal() {
    this.setState({
      showLoginModal: !this.state.showLoginModal,
    });
  }

  logout() {
    localStorage.removeItem("loginData");
    this.props.history.push("/");
    // window.location.reload();
  }

  submitLoginForm = (event) => {
    const { email, password } = this.state;
    if (email != "" && password != "") {
      if (validateEmailAddress(email)) {
        this.setState(
          {
            credError: "", // removing the error message
            loginLoader: true,
          },
          () => {
            this.props.doLogin(
              email,
              password,
              window.location.host === "feeds.lincolnmethod.com" ||
                window.location.host === "localhost:3000" ||
                window.location.host === "localhost:3001"
                ? 2
                : 2
            ); // calling the action to login in now
          }
        );
      } else {
        this.setState({
          credError: "Email is not valid.",
        });
      }
    } else {
      this.setState({
        credError: "Email and Password is required.",
      });
    }
  };

  componentWillUnmount() {}

  switchtoEm = () => {
    this.setState({
      switchRoute: !this.state.switchRoute,
    });
    this.props.history.push("/dashboard");
  };
  render() {
    var strArr = window.location.hash.split("#/");
    //console.log("Route String", strArr);
    const { loginType } = this.state;
    return (
      <div className="HeaderComponent" id="HeaderComponent">
        {/* Modal popup starts here */}
        <Modal isOpen={this.state.showLoginModal} size="sm" centered className="loginModal">
          <ModalHeader>Login</ModalHeader>
          <ModalBody style={{ textAlign: "center" }}>
            <FormGroup style={{ position: "relative" }}>
              {this.state.credError && this.state.credError.length ? (
                <p style={{ color: "red" }}>{this.state.credError}</p>
              ) : null}
              <Input
                type="email"
                name="login_email"
                id="login_email"
                placeholder="Your email *"
                onChange={(evt) => {
                  this.setState({ email: evt.target.value });
                }}
              />
            </FormGroup>
            <FormGroup>
              <Input
                type="password"
                name="password"
                id="login_password"
                placeholder="Password *"
                onChange={(evt) => {
                  this.setState({ password: evt.target.value });
                }}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="warning" onClick={this.submitLoginForm}>
              Login
            </Button>
            {this.state.loginLoader ? (
              <div class="spinner-border text-dark" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            ) : null}
          </ModalFooter>
        </Modal>

        {/* Modal popup ends here */}

        <Navbar color="" expand="md" style={{ background: "#343a40" }}>
          <NavbarBrand>
            <Media src={this.state.logoImage} height="40" />
          </NavbarBrand>
          {isMobileBrowser() ? (
            <Nav className="ml-auto text-left userMenuMobile" navbar>
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav>
                  <Label style={{ color: "#FED02A" }}>
                    <NavbarText className="text-light font-weight-bold mt-2 m-2">
                      {this.state.emName}
                      {this.state.loginType == 1 ? (
                        <sup style={{ marginLeft: 2, fontFamily: "Caveat", fontSize: 18 }}>
                          Tutor
                        </sup>
                      ) : this.state.loginType == 2 ? (
                        <sup style={{ marginLeft: 2, fontFamily: "Caveat", fontSize: 14 }}>
                          Education Mama
                        </sup>
                      ) : (
                        ""
                      )}
                    </NavbarText>
                  </Label>
                  {/* <span></span> */}
                </DropdownToggle>
              </UncontrolledDropdown>
            </Nav>
          ) : null}
          {/* <NavbarToggler onClick={this.toggle} /> */}
          {isMobileBrowser() && (
            <button className="ml-2 btn btn-light btn-sm btn-rounded">
              <i className="fa fa-bars" onClick={this.toggle} />
            </button>
          )}
          <Collapse isOpen={this.state.isOpen} navbar>
            {/* <Link to="/Teacherdashboard/OngoingClasses">
                            <NavLink style={{ color: "#fff" }}>On Going Classes</NavLink>
                        </Link> */}
            <Nav className="ml-auto text-left" navbar>
              {/* {this.state.multipleRole ? (
                <NavItem>
                  <NavbarText className="text-light font-weight-bold mt-2 switchforRole">
                    <Switch
                      checked={this.state.switchRoute}
                      onChange={this.switchtoEm}
                      uncheckedIcon={<div className="textForswitch">Education Mama</div>}
                      checkedIcon={<div className="textForswitchRight">Tutor</div>}
                      className={
                        this.state.switchRoute
                          ? "highest react-switch medium"
                          : "lowest react-switch medium"
                      }
                      id="icon-switch"
                    />
                  </NavbarText>
                </NavItem>
              ) : null} */}
              <NavItem>
                <NavbarText className="text-light font-weight-bold mt-2 m-2">
                  {this.state.emName}
                  {this.state.loginType == 1 ? (
                    <sup style={{ marginLeft: 2, fontFamily: "Caveat", fontSize: 18 }}>Tutor</sup>
                  ) : this.state.loginType == 2 ? (
                    <sup style={{ marginLeft: 2, fontFamily: "Caveat", fontSize: 14 }}>
                      Education Mama
                    </sup>
                  ) : (
                    ""
                  )}
                </NavbarText>
                {this.state.imageName !== null ? (
                  <img
                    src={`https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${this.state.imageName}`}
                    alt="Avatar"
                    className="avatarStudent"
                  />
                ) : (
                  <img
                    src={require("../../public/images/emptyuserphoto.png")}
                    alt="Avatar"
                    className="avatarStudent"
                  />
                )}
              </NavItem>

              {/* {strArr[1] != "dashboard" && strArr[1] != "Teacherdashboard" ? (
                                <NavbarText className="mb-4">
                                    <Switch
                                        checked={!this.state.isTuitionsPostType}
                                        onChange={() => this.onToggleSwitch()}
                                        uncheckedIcon={<div className="switchLabel">Tuitions</div>}
                                        checkedIcon={<div className="switchLabel">Self learning</div>}
                                        className={
                                            this.state.isTuitionsPostType
                                                ? "highest react-switch medium"
                                                : "lowest react-switch medium"
                                        }
                                        id="icon-switch"
                                    />
                                </NavbarText>
                            ) : null} */}

              <NavbarText className="text-light font-weight-bold mt-2 ml-2">
                <Button
                  size="sm"
                  style={{ backgroundColor: "#FED700", color: "black" }}
                  onClick={this.logout}
                >
                  Logout
                </Button>
              </NavbarText>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}

HeaderForTeacher.propTypes = {
  switchToWhiteLabelView: PropTypes.func.isRequired,
  doLogin: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  loginSuccessNormal: state.feedRed.loginSuccessNormal,
});

export default connect(mapStateToProps, { switchToWhiteLabelView, doLogin })(
  withRouter(HeaderForTeacher)
);
